/**
 * Prevents the browser from scrolling to the first focusable element
 * when a dialog is opened with show() or showModal().
 *
 * If the dialog's first child is scrollable (content taller than viewport),
 * it receives focus with preventScroll and its scroll position is reset.
 * This fixes Firefox and Safari auto-scrolling to the first focusable element.
 */
export const preventDialogScroll = (dialog: HTMLDialogElement) => {
  dialog.scrollTop = 0;
};
